import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from "rxjs";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { CapacityType} from "../../../enums/capacity-type.enum";
import { CreateCapacityForVenuesComponent } from "../create-capacity-for-venues/create-capacity-for-venues.component";
import { AddCapacityTemplateFormComponent } from "../add-capacity-template-form/add-capacity-template-form.component";

@Component({
  selector: 'app-choose-capacity-type-dialog',
  templateUrl: './choose-capacity-type-dialog.component.html',
  styleUrls: ['./choose-capacity-type-dialog.component.scss']
})
export class ChooseCapacityTypeDialogComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>()
  @ViewChild('rangeCalendar') dateRangePickerControl: any;
  public capacityTypeEnum = CapacityType;
  public selectedType = CapacityType.DEFAULT;
  public venueId: string;
  public fromAddVenue: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    public ref: DynamicDialogRef,
    private dialogService: DialogService,
    private config: DynamicDialogConfig,
    public messageService: MessageService,
    public translate: TranslateService
  ) {
    if (this.config.data != undefined && this.config.data.venueId) {
      this.venueId = this.config.data.venueId;
    }
    if (this.config.data != undefined && this.config.data.fromAddVenue) {
      this.fromAddVenue = this.config.data.fromAddVenue;
    }
  }

  public ngOnInit(): void {

  }
  //#endregion

  //#region Public Methods
  public openDialog(): void {
    if (this.selectedType === CapacityType.DEFAULT) {
      const ref = this.dialogService.open(CreateCapacityForVenuesComponent, {
        data: {
          id: this.venueId,
          default: true,
          fromAddVenue: this.fromAddVenue
        },
        width: '1000px',
        styleClass: '',
        header: 'Default capacity'
      });
      ref.onClose.subscribe((item: any) => {
        if (item) {
          this.ref.close(item);
        }
      });
    } else {
      const ref = this.dialogService.open(AddCapacityTemplateFormComponent, {
        data: {
          id: this.venueId,
          default: false,
          fromAddVenue: this.fromAddVenue
        },
        header: this.translate.instant('VENUE.ADD_CAPACITY'),
        width: '650px',
        styleClass: 'create_capacity_template_dialog w_300_px_mbl',
        closable: false
      });

      ref.onClose.subscribe((item: any) => {
        if (item) {
          this.ref.close(item);
        }
      });
    }
  }

  public chooseType(type: CapacityType): void {
    this.selectedType = type;
  }

  public isTypeSelected(type: CapacityType): boolean {
    return this.selectedType === type;
  }

  public cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
